import React, { useState } from 'react'
import styles from './modal.module.css'
import { Box, Button, IconButton, InputAdornment, Checkbox, TextField } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ModalCalendar from './ModalCalendar';
import dayjs from 'dayjs'
import moment from 'moment/moment'
import * as api from '../../pages/services/api'
import CustomizedModal from '../../components/modal/CustomizedModal';

function ModalExportAssessment({ onClose,evaluation_code}) {

    const [openCalendar, setOpenCalendar] = useState(false)
    const [disabledDay, setDisabledDay] = useState([])
    const [typeDate, setTypeDate] = useState('')
    const [dateStart, setDateStart] = useState(dayjs(moment(new Date()).startOf('month').format('YYYY-MM-DD')))
    const [dateEnd, setDateEnd] = useState(dayjs(moment(new Date()).endOf('month').format('YYYY-MM-DD')))
    const [exportAll, setExportAll] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleClickDate = (type) => {
        setTypeDate(type)
        setOpenCalendar(true)
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const handleClickExportCSV = async () => {
        let properties;
        let res = await api.getAssessmentHistory(evaluation_code);
        if (res) {
            if (res['data']['code'] === 200) {
                let data = res['data']['data'];
                let predefinedColumns = [
                    { "column_number": 1, "key": "evaluate_date", "name": "วันที่ทำแบบประเมิน" },
                    { "column_number": 2, "key": "pid", "name": "เลขบัตรประจำตัวประชาชน" },
                    { "column_number": 3, "key": "fullname", "name": "ชื่อ-นามสกุล" },
                ];
                let excludedKeys = new Set(["evaluation_code","doc_number","evaluation_detail","evaluation_image","evaluation_name","evaluation_number"]);
                let uniqueKeys = new Set(predefinedColumns.map((col) => col.key));
                let dynamicColumns = Object.keys(data[0].result)
                    .filter((key) => !excludedKeys.has(key)) 
                    .map((key, index) => {
                        if (!uniqueKeys.has(key)) {
                            uniqueKeys.add(key);
                            return {
                                column_number: predefinedColumns.length + index + 1,
                                key: key,
                                name: key, 
                            };
                        }
                        return null; 
                    })
                    .filter((col) => col !== null);
                properties = [...predefinedColumns, ...dynamicColumns];
            } 
        } else {
            alert('ไม่ตอบสนอง');
        }

        if (exportAll) {
            res = await api.exportAssessment(
                evaluation_code,
                dayjs('2025-01-01'),
                dayjs('3500-12-31'),
                properties
            );
        } else {
            res = await api.exportAssessment(
                evaluation_code,
                moment(new Date(dateStart)).format('YYYY-MM-DD'),
                moment(new Date(dateEnd)).format('YYYY-MM-DD'),
                properties
            );
        }

        if (res) {
            if (res['data']['code'] === 200) {
                let data = res['data']['data']['file_url'];
                window.open(data, '_blank');
            } else {
                setErrorMessage("ไม่พบข้อมูลที่ต้องการส่งออก");
            }
        } else {
            alert('ไม่ตอบสนอง');
        }
    }

    return (
        <>
            {/* Error Modal: Not found data to export */}
            {errorMessage && (
                        <CustomizedModal
                        onClose={() => setErrorMessage(null)}
                        confirmMessage={errorMessage}
                        apiCall={() => setErrorMessage(null)}
                        confirmButtonText="ตกลง"
                        />
                    )}
            {openCalendar &&
                <ModalCalendar
                    onClose={() => { setOpenCalendar(false) }}
                    onSubmit={() => {
                        setOpenCalendar(false)
                    }}
                    value={
                        typeDate === 'start' ?
                            dateStart ? dayjs(moment(dateStart['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))
                            :
                            dateEnd ? dayjs(moment(dateEnd['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))
                    }
                    setValue={(e) => {
                        typeDate === 'start' ? setDateStart(e) : setDateEnd(e)
                    }}
                    disableDay={disabledDay}
                />
            }
            <Box className={styles.backgroundModal2}>
                <Box className={styles.boxModal2}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>Export</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={() => { onClose() }}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridGap: '15px'
                    }}>
                        <Box sx={{
                            display: 'flex',
                            gridGap: '10px',
                            marginTop: '15px',
                            "@media (max-width: 800px)": {
                                display: 'grid'
                            },
                        }}>
                            <Box>
                                <Box>เลือกวันที่เริ่ม</Box>
                                <TextField
                                    fullWidth
                                    size='small'
                                    sx={{ ...SelectCss }}
                                    value={dateStart === '' ? 'เลือกวันที่เริ่ม' : convertDate(dateStart)}
                                    InputProps={{
                                        inputProps: {
                                            readOnly: true,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { handleClickDate('start') }}
                                                >
                                                    <CalendarTodayIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>
                            <Box>
                                <Box>เลือกวันที่สิ้นสุด</Box>
                                <TextField
                                    fullWidth
                                    size='small'
                                    sx={{ ...SelectCss }}
                                    value={dateEnd === '' ? 'เลือกวันที่สิ้นสุด' : convertDate(dateEnd)}
                                    InputProps={{
                                        inputProps: {
                                            readOnly: true,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { handleClickDate('end') }}
                                                >
                                                    <CalendarTodayIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '10px'}}>
                            <Checkbox
                                checked={exportAll}
                                onChange={(e) => setExportAll(e.target.checked)}
                                inputProps={{ 'aria-label': 'Checkbox for Export All' }}
                            />
                            <label htmlFor="exportAll">Export ทั้งหมด</label>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                variant='contained'
                                onClick={() => { handleClickExportCSV() }}
                            >export</Button>
                        </Box>
                    </Box>

                </Box>
            </Box>
        </>
    )
}

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
}

export default ModalExportAssessment
